exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-editors-strapi-editor-slug-js": () => import("./../../../src/pages/editors/{StrapiEditor.slug}.js" /* webpackChunkName: "component---src-pages-editors-strapi-editor-slug-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-posts-strapi-post-slug-js": () => import("./../../../src/pages/posts/{StrapiPost.slug}.js" /* webpackChunkName: "component---src-pages-posts-strapi-post-slug-js" */)
}

